import { Ticket } from "database";
import moment from "moment";
export enum TicketStatus {
  UPCOMING = "Upcoming",
  ON_SALE = "On Sale",
  ENDED = "Ended",
}
export const getTicketSaleStatus = (
  ticket: Ticket & { saleStartDate: Date; saleEndDate: Date }
) => {
  if (moment(ticket.saleStartDate).utc() > moment().utc()) {
    return TicketStatus.UPCOMING;
  } else if (
    moment(ticket.saleStartDate).utc() < moment().utc() &&
    moment(ticket.saleEndDate).utc() > moment().utc()
  ) {
    return TicketStatus.ON_SALE;
  } else {
    return TicketStatus.ENDED;
  }
};
